<template>
  <div class="row">
    <div class="col-xl-12">
      <div
        class="kt-portlet kt-portlet--last kt-portlet--head-lg kt-portlet--responsive-mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-priceTier flaticon2-writing"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              <p class="mt-2 mb-0">
                ข้อมูล CN ของใบงาน ประเภทรับคืนสินค้า/ทรัพย์สินจากลูกค้า เลขที่
                <strong>{{ jobNumber }}</strong>
              </p>
            </h3>
          </div>
          <div class="kt-portlet__head-toolbar">
            <button
              type="button"
              @click.prevent="$router.go(-1)"
              class="btn btn-sm btn-clean kt-margin-r-10"
            >
              <i class="la la-arrow-left"></i>
              <span class="kt-hidden-mobile">กลับ</span>
            </button>
          </div>
        </div>
        <div class="kt-portlet__body">
          <form
            autocomplete="off"
            class="kt-form"
            id="jobForm"
            ref="jobForm"
            @submit="formSubmit"
          >
            <div class="kt-section kt-section--first">
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-4 col-md-4 col-xl-4">
                    <div class="form-group">
                      <label class="label"
                        >BARCODE/รหัสทรัพย์สิน(เบียร์สด):</label
                      >
                      <input
                        v-model="cnFormBarcode"
                        type="text"
                        class="form-control"
                        placeholder="ค้นหาจาก BARCODE, รหัสทรัพย์สิน(เบียร์สด)"
                      />
                    </div>
                  </div>

                  <div class="col-sm-4 col-md-4 col-xl-4">
                    <div class="form-group">
                      <label class="label">สินค้า:</label>
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'cnFormMaterialCode'"
                        :name="'cnFormMaterialCode'"
                        :select2-options="cnFormMaterialCodeOptions"
                        multiple
                        v-model="cnFormMaterialCode"
                      ></select2>
                    </div>
                  </div>

                  <div class="col-sm-4 col-md-4 col-xl-4">
                    <div class="form-group">
                      <label class="label">คลังสินค้าที่จ่ายออก:</label>
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'cnFormOriginPlant'"
                        :name="'cnFormOriginPlant'"
                        :select2-options="cnFormOriginPlantOptions"
                        multiple
                        v-model="cnFormOriginPlant"
                      ></select2>
                    </div>
                  </div>

                  <div class="col-sm-4 col-md-4 col-xl-4">
                    <div class="form-group">
                      <label class="label"
                        >ตัวแทนฯที่ได้รับจากคลังสินค้า:</label
                      >
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'cnFormDestinationAgent'"
                        :name="'cnFormDestinationAgent'"
                        :select2-options="cnFormDestinationAgentOptions"
                        multiple
                        v-model="cnFormDestinationAgent"
                      ></select2>
                    </div>
                  </div>

                  <div class="col-sm-4 col-md-4 col-xl-4">
                    <div class="form-group">
                      <label class="label">การคืน:</label>
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'cnFormCNStatus'"
                        :name="'cnFormCNStatus'"
                        :select2-options="cnFormCNStatusOptions"
                        multiple
                        v-model="cnFormCNStatus"
                      ></select2>
                    </div>
                  </div>

                  <div class="col-sm-4 col-md-4 col-xl-4">
                    <div class="form-group">
                      <label class="label">ระบบ CN ให้(ตัวแทนฯ):</label>
                      <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'cnFormCNToAgent'"
                        :name="'cnFormCNToAgent'"
                        :select2-options="cnFormCNToAgentOptions"
                        multiple
                        v-model="cnFormCNToAgent"
                      ></select2>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <button
                      class="btn btn-primary"
                      @click="getJobCN"
                      type="submit"
                    >
                      <span>ค้นหา</span>
                    </button>
                    <button
                      type="reset"
                      class="btn btn-secondary"
                      @click="getJobCNReset"
                    >
                      ล้างค่าทั้งหมด
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="kt-section kt-section--first">
              <h3 class="kt-section__title">รายการ:</h3>
              <div class="kt-section__body">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table
                      class="table table-sm table-striped table-bordered table-hover table-checkable display nowrap"
                      style="width:100%"
                    >
                      <thead>
                        <tr>
                          <th class="text-center align-middle" width="5%">
                            ลำดับ
                          </th>
                          <th class="text-center align-middle" width="15%">
                            BARCODE<br />(รหัสทรัพย์สิน(เบียร์สด))
                          </th>
                          <th class="text-center align-middle" width="15%">
                            รหัสสินค้า<br />ชื่อสินค้า
                          </th>
                          <th class="text-center align-middle" width="15%">
                            รหัสคลัง<br />คลังสินค้าที่จ่ายออก
                            <a
                              href="#"
                              @click.prevent="confirmCopyOriginPlant"
                              title="คัดลอกรหัสคลังทั้งหมด ตามข้อมูลแถวที่ 1"
                              class="btn btn-sm btn-clean btn-icon btn-icon-md text-warning"
                            >
                              <i class="la la-copy"></i>
                            </a>
                          </th>
                          <th class="text-center align-middle" width="10%">
                            รหัสตัวแทนฯ <br />
                            ตัวแทนฯที่ได้รับจากคลังสินค้า
                          </th>
                          <th class="text-center align-middle" width="8%">
                            การคืน
                          </th>
                          <th class="text-center align-middle" width="15%">
                            ระบบ CN ให้(ตัวแทนฯ)
                          </th>
                          <th
                            class="text-center align-middle"
                            style="color:#0277bd"
                            width="15%"
                          >
                            แก้ไข CN ให้(ตัวแทนฯ)
                            <a
                              v-if="this.$root.canShow(['super_admin'])"
                              href="#"
                              @click.prevent="confirmCopyCnToAgentCode"
                              title="คัดลอกแก้ไข CN ให้(ตัวแทนฯ) ทั้งหมด ตามข้อมูลแถวที่ 1"
                              class="btn btn-sm btn-clean btn-icon btn-icon-md text-warning"
                            >
                              <i class="la la-copy"></i>
                            </a>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(item, i) in jobCNItems">
                          <job-cn-item-row
                            ref="jobCNItems"
                            :key="i"
                            :rowIndex="i"
                            :item="item"
                          ></job-cn-item-row>
                        </template>
                      </tbody>
                      <tfoot></tfoot>
                    </table>
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="form-group">
                          <label>หมายเหตุ:</label>
                          <textarea
                            placeholder="หมายเหตุ"
                            class="form-control"
                            v-model="cnRemark"
                            rows="5"
                            :maxlength="maxLength"
                          ></textarea>
                          <span class="form-text"></span>
                          <span style="float: right" v-if="cnRemark"
                            >{{ cnRemark.length }} / {{ maxLength }}</span
                          >
                          <span
                            style="float: right"
                            v-if="!cnRemark || cnRemark == ''"
                            >0 / {{ maxLength }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="kt-portlet__foot">
          <div class="row">
            <div class="col-lg-12 kt-align-right">
              <button
                type="button"
                @click.prevent="$router.go(-1)"
                class="btn btn-sm btn-clean kt-margin-r-10"
              >
                <i class="la la-arrow-left"></i>
                <span class="kt-hidden-mobile">กลับ</span>
              </button>
              <button
                type="button"
                @click="formSubmit"
                class="btn btn-sm btn-primary kt-margin-r-10"
              >
                <span class="kt-hidden-mobile">บันทึกข้อมูล</span>
              </button>
              <button
                type="button"
                @click="formSubmitConfirm()"
                class="btn btn-sm kt-margin-r-10"
                style="background-color:#7700cf; color:#FFFFFF"
              >
                <span class="kt-hidden-mobile">ยืนยันข้อมูล CN</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import select2 from "../../Shared/Select2";
import jobCnItemRow from "./JobCNItemRow";

export default {
  components: {
    select2,
    jobCnItemRow,
  },
  data() {
    var self = this;
    return {
      jobNumber: null,
      cnFormBarcode: null,
      cnFormMaterialCode: [],
      cnFormOriginPlant: [],
      cnFormDestinationAgent: [],
      cnFormCNStatus: [],
      cnFormCNToAgent: [],
      jobCNItems: [],
      cnRemark: null,
      maxLength: 350,
      cnFormMaterialCodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cnFormOriginPlantOptions: {
        placeholder: "กรุณาเลือกคลังสินค้าที่จ่ายออก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Plant/PlantOptions",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cnFormDestinationAgentOptions: {
        placeholder: "กรุณาเลือกตัวแทนฯที่ได้รับจากคลังสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cnFormCNStatusOptions: {
        placeholder: "กรุณาเลือกการคืน",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "CN_STATUS",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      cnFormCNToAgentOptions: {
        placeholder: "กรุณาเลือกระบบ CN ให้(ตัวแทนฯ)",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formSubmit: function(e) {
      //e.preventDefault();

      let self = this;
      let router = this.$router;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดำเนินการ กรุณารอสักครู่...",
      });

      var cnItems = [];
      self.jobCNItems.forEach((element) => {
        if(element.cnToAgentCode2==""){
          element.cnToAgentCode2 = null
        }
        cnItems.push({
          Id: element.id,
          OriginPlantCode2: element.originPlantCode2,
          DestinationAgentCode2: element.destinationAgentCode2,
          CNToAgentCode2: element.cnToAgentCode2,
        });
      });

      axios({
        method: "put",
        url: "/Api/JobsCN/UpdateJobCN",
        data: {
          jobId: this.$route.params.id,
          isConfirm: false,
          obj: cnItems,
          cnRemark: self.cnRemark,
        },
      })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire(
              "สำเร็จ",
              "บันทึกข้อมูล CN ของใบงานสำเร็จ",
              "success"
            ).then(function() {
              //router.go(-1), self.$parent.reloadDataTable(false);
              self.getJobCN(e);
            });
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    formSubmitConfirm: function(e) {
      //e.preventDefault();

      let self = this;
      let router = this.$router;

      var cnItems = [];
      self.jobCNItems.forEach((element) => {
        cnItems.push({
          Id: element.id,
          OriginPlantCode2: element.originPlantCode2,
          DestinationAgentCode2: element.destinationAgentCode2,
          CNToAgentCode2: element.cnToAgentCode2 || null,
        });
      });

      Swal.fire({
        title: "ต้องการยืนยันข้อมูล CN ใช่หรือไม่ ?",
        type: "warning",
        html:
          "เมื่อยืนยันข้อมูล CN จะไม่สามารถ แก้ไขข้อมูลในภายหลังได้ <strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
          });

          axios({
            method: "put",
            url: "/Api/JobsCN/UpdateJobCN",
            data: {
              jobId: this.$route.params.id,
              isConfirm: true,
              obj: cnItems,
            },
          })
            .then(function(response) {
              if (response.data.status) {
                Swal.fire(
                  "สำเร็จ",
                  "ยืนยันข้อมูล CN ของใบงานสำเร็จ",
                  "success"
                ).then(function() {
                  router.go(-1), self.$parent.reloadDataTable(false);
                });
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    getJobCN: function(e) {
      e.preventDefault();

      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
      });

      self.jobCNItems = [];

      axios({
        method: "post",
        url: "/Api/JobsCN/GetJobCN",
        data: {
          jobId: this.$route.params.id,
          barcode: self.cnFormBarcode,
          materialCode: self.cnFormMaterialCode,
          originPlant: self.cnFormOriginPlant,
          destinationAgent: self.cnFormDestinationAgent,
          status: self.cnFormCNStatus,
          toAgent: self.cnFormCNToAgent,
        },
      })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data;
            self.jobNumber = data.jobNumber;
            self.cnRemark = data.cnRemark;
            self.jobCNItems = data.items;

            if (response.data.items.length > 0) {
              for (let i = 0; i < response.data.items.length; i++) {
                var item = response.data.items[i];

                setTimeout(function() {
                  if (self.jobCNItems[i].cnToAgentCode2 !== null) {
                    self.$refs.jobCNItems[
                      i
                    ].$refs.cnToAgentCode2.setSelectedData({
                      id: response.data.items[i].cnToAgentCode2,
                      text:
                        "[ " +
                        response.data.items[i].cnToAgentCode2 +
                        " ] " +
                        response.data.items[i].cnToAgentName2,
                    });
                  }

                  if (self.jobCNItems[i].originPlantCode2 !== null) {
                    self.$refs.jobCNItems[
                      i
                    ].$refs.originPlantCode2.setSelectedData({
                      id: response.data.items[i].originPlantCode2,
                      text:
                        "[ " +
                        response.data.items[i].originPlantCode2 +
                        " ] " +
                        response.data.items[i].originPlantName2,
                    });
                  }
                  //default โรงงานที่ส่งออก
                  else if(self.jobCNItems[i].originPlantCode !== null)
                  {
                    self.jobCNItems[i].originPlantCode2 = self.jobCNItems[i].originPlantCode;

                    self.$refs.jobCNItems[
                      i
                    ].$refs.originPlantCode2.setSelectedData({
                      id: response.data.items[i].originPlantCode,
                      text:
                        "[ " +
                        response.data.items[i].originPlantCode +
                        " ] " +
                        response.data.items[i].originPlantName,
                    });
                  }
                }, 50);
              }
            }
          } else {
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
            KTApp.unblockPage();
          }
        })
        .catch(function(error) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้",
            "error"
          );
          KTApp.unblockPage();
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    getJobCNReset: function(e) {
      let self = this;

      self.cnFormBarcode = null;
      self.cnFormMaterialCode = [];
      self.jobCNItems = [];
      $("#cnFormMaterialCode")
        .val("")
        .trigger("change");

      self.cnFormOriginPlant = [];
      $("#cnFormOriginPlant")
        .val("")
        .trigger("change");

      self.cnFormDestinationAgent = [];
      $("#cnFormDestinationAgent")
        .val("")
        .trigger("change");

      self.cnFormCNStatus = [];
      $("#cnFormCNStatus")
        .val("")
        .trigger("change");

      self.cnFormCNToAgent = [];
      $("#cnFormCNToAgent")
        .val("")
        .trigger("change");

      self.getJobCN(e);
    },
    confirmCopyOriginPlant: function(e) {
      Swal.fire({
        title: "คำสั่งคัดลอกรหัสคลัง",
        type: "warning",
        html: "กรุณายืนยันคำสั่งคัดลอกรหัสคลังทั้งหมด ตามข้อมูลแถวที่ 1",
        inputPlaceholder: "ต้องการคัดลอกรหัสคลัง",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value == true) {
          this.copyOriginPlant();
        }
      });
    },
    copyOriginPlant() {
      let self = this;
      var plantCode = "";
      var plantText = "";

      for (let i = 0; i < self.jobCNItems.length; i++) {
        var element = self.jobCNItems[i];

        if (i == 0) {
          plantCode = element.originPlantCode2;
          if(element.originPlantText){
            plantText = element.originPlantText;
          }else{
            plantText = "[ " +element.originPlantCode2 +" ] " + element.originPlantName2;
          }
        } else {
          element.originPlantCode2 = plantCode;

          setTimeout(function() {
            if (element.originPlantCode2 !== "") {
              self.$refs.jobCNItems[i].$refs.originPlantCode2.setSelectedData({
                id: plantCode,
                text: plantText,
              });
            } else {
              self.$refs.jobCNItems[i].$refs.originPlantCode2.setSelectedData({
                id: null,
                text: null,
              });
            }
          }, 50);
        }
        //console.log(element.originPlantCode2);
        //console.log(element);
      }
    },
    confirmCopyCnToAgentCode: function(e) {
      Swal.fire({
        title: "คำสั่งคัดลอกแก้ไข CN ให้(ตัวแทนฯ)",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งคัดลอกแก้ไข CN ให้(ตัวแทนฯ) ทั้งหมด ตามข้อมูลแถวที่ 1",
        inputPlaceholder: "ต้องการคัดลอกแก้ไข CN ให้(ตัวแทนฯ)",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value == true) {
          this.copyCnToAgentCode();
        }
      });
    },
    copyCnToAgentCode() {
      let self = this;
      var agentCode = "";
      var agentText = "";

      for (let i = 0; i < self.jobCNItems.length; i++) {
        var element = self.jobCNItems[i];

        if (i == 0) {
          agentCode = element.cnToAgentCode2;
          if(element.originPlantText){
            agentText = element.cnToAgentText2;
          }else{
            agentText = "[ " +element.cnToAgentCode2 +" ] " + element.cnToAgentName2;
          }
        } else {
          element.cnToAgentCode2 = agentCode;

          setTimeout(function() {
            if (element.cnToAgentCode2 !== "") {
              self.$refs.jobCNItems[i].$refs.cnToAgentCode2.setSelectedData({
                id: agentCode,
                text: agentText,
              });
            } else {
              self.$refs.jobCNItems[i].$refs.cnToAgentCode2.setSelectedData({
                id: null,
                text: null,
              });
            }
          }, 50);
        }
        // console.log("i ", i);
        // console.log("cnToAgentCode2 ", element.cnToAgentCode2);
        // console.log(element);
      }
    },
  },
  mounted() {
    var self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.jobForm).validate({
      ignore: ":hidden, .ignore",
      rules: {},
      messages: {},
    });

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios({
      method: "post",
      url: "/Api/JobsCN/GetJobCN",
      data: {
        jobId: this.$route.params.id,
        barcode: self.cnFormBarcode,
        materialCode: self.cnFormMaterialCode,
        originPlant: self.cnFormOriginPlant,
        destinationAgent: self.cnFormDestinationAgent,
        status: self.cnFormCNStatus,
        toAgent: self.cnFormCNToAgent,
      },
    })
      .then(function(response) {
        if (response.status == 200) {
          var data = response.data;
          self.jobNumber = data.jobNumber;
          self.cnRemark = data.cnRemark;
          self.jobCNItems = data.items;

          if (response.data.items.length > 0) {
            for (let i = 0; i < response.data.items.length; i++) {
              var item = response.data.items[i];

              setTimeout(function() {
                if (self.jobCNItems[i].cnToAgentCode2 !== null) {
                  self.$refs.jobCNItems[i].$refs.cnToAgentCode2.setSelectedData(
                    {
                      id: response.data.items[i].cnToAgentCode2,
                      text:
                        "[ " +
                        response.data.items[i].cnToAgentCode2 +
                        " ] " +
                        response.data.items[i].cnToAgentName2,
                    }
                  );
                }

                if (self.jobCNItems[i].originPlantCode2 !== null) {
                  self.$refs.jobCNItems[
                    i
                  ].$refs.originPlantCode2.setSelectedData({
                    id: response.data.items[i].originPlantCode2,
                    text:
                      "[ " +
                      response.data.items[i].originPlantCode2 +
                      " ] " +
                      response.data.items[i].originPlantName2,
                  });
                }
                //default โรงงานที่ส่งออก
                else if(self.jobCNItems[i].originPlantCode !== null)
                {
                  self.jobCNItems[i].originPlantCode2 = self.jobCNItems[i].originPlantCode;

                  self.$refs.jobCNItems[
                    i
                  ].$refs.originPlantCode2.setSelectedData({
                    id: response.data.items[i].originPlantCode,
                    text:
                      "[ " +
                      response.data.items[i].originPlantCode +
                      " ] " +
                      response.data.items[i].originPlantName,
                  });
                }
              }, 50);
            }
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
          KTApp.unblockPage();
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้",
          "error"
        );
        KTApp.unblockPage();
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
    $(this.$refs.jobForm).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Job/JobCNForm.vue